import { type ComponentType, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { type DetailedPublicTemplateResponse } from '../../../../contracts';
import { communityTemplateDetailsMessages } from '../../communityTemplateDetails.messages';

interface DetailsHeadMetaProps {
  Head: ComponentType<{ children: ReactNode }>;
  metaDescription: string;
  metaKeywords: string;
  pageTitle: string;
  template: DetailedPublicTemplateResponse | undefined;
}

export const DetailsHeadMeta = ({
  metaDescription,
  metaKeywords,
  pageTitle,
  template,
  Head,
}: DetailsHeadMetaProps) => {
  const intl = useIntl();

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="article" />

      {template && (
        <>
          <meta
            name="author"
            content={
              template.author_name ||
              intl.formatMessage(communityTemplateDetailsMessages.defaultAuthorBrand)
            }
          />
          <meta name="keywords" content={metaKeywords} />
          <meta property="article:published_time" content={template.created_at} />
          <meta property="article:modified_time" content={template.updated_at} />
        </>
      )}
    </Head>
  );
};
